import { render, staticRenderFns } from "./SectionTicketDetails.vue?vue&type=template&id=34334a2e&scoped=true&"
import script from "./SectionTicketDetails.vue?vue&type=script&lang=js&"
export * from "./SectionTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./SectionTicketDetails.vue?vue&type=style&index=0&id=34334a2e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34334a2e",
  null
  
)

export default component.exports